"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelledField = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var FormikTextBox_1 = require("./FormikTextBox");
/**
 * A wrapper component which layous a field with a lable and any validation error messages.
 *
 * This directly uses the formik context to understand the touched and error states of the input.
 *
 * See the forms README for more details on the two modes of operation of this flexible component.
 *
 * @param props
 * @returns
 */
var LabelledField = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    /**
     * Read the label and name from the child component if it has one. This is primarily to ensure we don't
     * have to double up the properties and also facilitates more automatic layout of lists of
     * fields.
     */
    var label = (_a = props.label) !== null && _a !== void 0 ? _a : (_c = (_b = props.children) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.label;
    var name = (_d = props.name) !== null && _d !== void 0 ? _d : (_f = (_e = props.children) === null || _e === void 0 ? void 0 : _e.props) === null || _f === void 0 ? void 0 : _f.name;
    var formikContext = formik_1.useFormikContext();
    var touched = false;
    var error = '';
    if (formikContext.touched) {
        touched = (_g = formik_1.getIn(formikContext.touched, name)) !== null && _g !== void 0 ? _g : false;
    }
    if (formikContext.errors) {
        error = (_h = formik_1.getIn(formikContext.errors, name)) !== null && _h !== void 0 ? _h : '';
    }
    // If the field is touched and there's an error, set const to the string value of that error
    // Equally if the form is submitted, but we haven't touched any fields yet, still show the errors.
    var feedbackText = (formikContext.submitCount > 0 || touched) && error ? error : undefined;
    var feedback = !!feedbackText ? morse_react_1.Field.Feedback.Error : undefined;
    /**
     * Determine the control to use if we don't have a child - and default to FormikTextBox
     */
    var Control = !props.control && !props.children ? FormikTextBox_1.FormikTextBox : props.control;
    return (react_1.default.createElement(morse_react_1.Field, __assign({ feedback: feedback, feedbackText: feedbackText }, props.fieldContainerProps),
        react_1.default.createElement(morse_react_1.Label, { htmlFor: name }, label !== null && label !== void 0 ? label : morse_react_1.wordifyCamelCase(name)),
        Control ? react_1.default.createElement(Control, __assign({ id: name, name: name }, props.controlProps)) : react_1.default.createElement(react_1.default.Fragment, null, props.children)));
};
exports.LabelledField = LabelledField;
//# sourceMappingURL=LabelledField.js.map